// Script adapted from https://github.com/lucide-icons/lucide/tree/main/packages/lucide#with-esmodules
import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Building2,
  ChevronDown,
  ChevronRight,
  createIcons,
  Mail,
  Phone,
  PhoneOff,
  Plus,
  ScanSearch,
  X,
} from 'lucide';

import ready from 'shared/helpers/ready';

import Facebook from './facebook';
import Instagram from './instagram';
import Linkedin from './linkedin';
import Twitter from './twitter';

ready(() =>
  createIcons({
    icons: {
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      ArrowUp,
      Building2,
      ChevronDown,
      ChevronRight,
      Facebook,
      Instagram,
      Linkedin,
      Mail,
      Plus,
      Phone,
      PhoneOff,
      ScanSearch,
      Twitter,
      X,
    },
  })
);
